module.exports = __webpack_public_path__ + "img/default_shop_banner_pc.8914f274.jpg";